import { styled, Typography } from "@mui/material";
import React from "react";
import GameLogosForm from "../tileDialog/GameLogosForm";
import { useTranslation } from "react-i18next";

const PREFIX = "footballCustom";

const classes = {
  baseContainer: `${PREFIX}-baseContainer`,
  contentContainer: `${PREFIX}-contentContainer`,
};

const FootballCustomContainer = styled("div")(({ theme }) => ({
  [`& .${classes.baseContainer}`]: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: "0 1rem",
    marginBottom: "1rem",
  },
  [`& .${classes.contentContainer}`]: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "130px",
    justifyContent: "space-between",
  },
}));

const FootballCustom = () => {
  const { t } = useTranslation();

  return (
    <FootballCustomContainer>
      <div className={classes.baseContainer}>
        <div className={classes.contentContainer}>
          <Typography
            variant="body1"
            sx={{ marginBottom: "1rem", textAlign: "center" }}
          >
            {t("myExpariences.form.footballAdvertisement")}
          </Typography>
          <GameLogosForm logoKey={"basketLogo"} />
        </div>
      </div>
    </FootballCustomContainer>
  );
};

export default FootballCustom;
